// 业务模块路由配置
export default {
  title: '业务管理',
  type: 'folder',
  name: Symbol('business'),
  route: '/business',
  inNav: true,
  icon: 'iconfont icon-yewuguanli',
  isElementIcon: false,
  order: 4,
  children: [
    // 超管专属：按项目查看（项目列表 + 下钻到项目内业务）
    {
      title: '项目管理',
      type: 'view',
      name: Symbol('business-project'),
      route: '/business/project',
      filePath: 'view/business/project/list.vue',
      inNav: true,
      icon: 'iconfont icon-xiangmu',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN'],
    },
    // 品牌方专用菜单
    {
      title: '应收账款管理',
      type: 'view',
      name: Symbol('account-receivable'),
      route: '/business/account-receivable',
      filePath: 'view/business/account-receivable/list.vue',
      inNav: true,
      icon: 'iconfont icon-zhangkuan',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'BRAND_OWNER'], // 品牌方和超管可见
    },
    {
      title: '数字凭证管理',
      type: 'view',
      name: Symbol('digital-certificate'),
      route: '/business/digital-certificate',
      filePath: 'view/business/digital-certificate/list.vue',
      inNav: true,
      icon: 'iconfont icon-pingzheng',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'BRAND_OWNER'], // 品牌方和超管可见
    },
    {
      title: '智能合约审核',
      type: 'view',
      name: Symbol('smart-contract'),
      route: '/business/smart-contract',
      filePath: 'view/business/smart-contract/list.vue',
      inNav: true,
      icon: 'iconfont icon-hetong',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'BRAND_OWNER'], // 品牌方和超管可见（品牌方审核）
    },
    {
      title: '融资管理',
      type: 'view',
      name: Symbol('financing'),
      route: '/business/financing',
      filePath: 'view/business/financing/list.vue',
      inNav: true,
      icon: 'iconfont icon-rongzi',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'BRAND_OWNER'], // 品牌方和超管可见
    },
    {
      title: '清算管理',
      type: 'view',
      name: Symbol('settlement'),
      route: '/business/settlement',
      filePath: 'view/business/settlement/list.vue',
      inNav: true,
      icon: 'iconfont icon-qingsuan',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'BRAND_OWNER'], // 品牌方和超管可见
    },
    {
      title: '资金流水',
      type: 'view',
      name: Symbol('capital-flow'),
      route: '/business/capital-flow',
      filePath: 'view/business/capital-flow/list.vue',
      inNav: true,
      icon: 'iconfont icon-liushui',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'BRAND_OWNER'], // 品牌方和超管可见
    },
    {
      title: '业务报告',
      type: 'view',
      name: Symbol('business-report'),
      route: '/business/report',
      filePath: 'view/business/report/index.vue',
      inNav: true,
      icon: 'iconfont icon-baogao',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'BRAND_OWNER'], // 品牌方和超管可见
    },
    // 供应商专用菜单
    {
      title: '我的应收账款',
      type: 'view',
      name: Symbol('supplier-account-receivable'),
      route: '/business/supplier/account-receivable',
      filePath: 'view/business/account-receivable/list.vue',
      inNav: true,
      icon: 'iconfont icon-zhangkuan',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'SUPPLIER'], // 供应商和超管可见
    },
    {
      title: '提交合同',
      type: 'view',
      name: Symbol('contract-submit'),
      route: '/business/contract/submit',
      filePath: 'view/business/contract/submit.vue',
      inNav: true,
      icon: 'iconfont icon-tijiao',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'SUPPLIER'], // 供应商和超管可见
    },
    {
      title: '我的合约',
      type: 'view',
      name: Symbol('supplier-smart-contract'),
      route: '/business/supplier/smart-contract',
      filePath: 'view/business/smart-contract/list.vue',
      inNav: true,
      icon: 'iconfont icon-hetong',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'SUPPLIER'], // 供应商和超管可见
    },
    {
      title: '我的融资',
      type: 'view',
      name: Symbol('supplier-financing'),
      route: '/business/supplier/financing',
      filePath: 'view/business/financing/list.vue',
      inNav: true,
      icon: 'iconfont icon-rongzi',
      isElementIcon: false,
      userTypes: ['SUPER_ADMIN', 'SUPPLIER'], // 供应商和超管可见
    },
  ],
}
